<div class="container" fxLayout="column" fxLayoutGap="10px">

    <div fxFlex>
        <div>
            <h1 style="text-align: center;font-weight: 600;">Contact Us</h1>
            <hr>
        </div>
    </div>
    <div fxFlex>
        <h2>Location Information</h2>
        <div fxLayout="column" fxLayout.gt-sm="row">
            <div fxFlex="50">
                <h2>Our Address</h2>
                <address>
              Srm University<br>
              Chennai, India<br>
            </address>
                <br>
                <div>
                    <a mat-raised-button href="tel:6263804262"><i class="fa fa-phone"></i> Call</a>
                    <a mat-raised-button href="https://github.com/pranjay-poddar"><i class="fa fa-github"></i> Github</a>
                    <a mat-raised-button href="mailto:pranjaypoddar@gmail.com"><i class="fa fa-envelope-o"></i> Email</a>
                </div>
            </div>
            <div fxFlex="50">
                <h2>Map of our Location</h2>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.3122618504103!2d80.04205281412254!3d12.823087221590756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f712b82a78d9%3A0xfdb944a3aee53831!2sSRM%20Institute%20of%20Science%20and%20Technology!5e0!3m2!1sen!2sin!4v1621441211854!5m2!1sen!2sin"
                    width="315" height="300" style="border:0;display: flex;justify-content: center;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>
    </div>

    <div fxFlex fxFlexOffset="20px" class="form-size">
        <h3 style="font-size: 160%;font-weight: 500;text-align: center;">Send Us Your Feedback</h3>
        <!-- <p>{{ feedbackForm.value | json }} {{ feedbackForm.status | json }}</p> -->

        <form novalidate [formGroup]="feedbackForm" #fform="ngForm" *ngIf="formview==true" (ngSubmit)="onSubmit()">
            <p>

                <mat-form-field class="half-width">
                    <input matInput formControlName="firstname" placeholder="First Name" type="text">
                    <mat-error *ngIf="(formErrors.firstname)">{{formErrors.firstname}}</mat-error>
                </mat-form-field>

                <mat-form-field class="half-width">
                    <input matInput formControlName="lastname" placeholder="Last Name" type="text">
                    <mat-error *ngIf="(formErrors.lastname)">{{formErrors.lastname}}</mat-error>
                </mat-form-field>

            </p>
            <p>
                <mat-form-field class="half-width">
                    <input matInput formControlName="telnum" placeholder="Tel. Number" type="number">
                    <mat-error *ngIf="(formErrors.telnum)">{{formErrors.telnum}}</mat-error>
                </mat-form-field>
                <mat-form-field class="half-width">
                    <input matInput formControlName="email" placeholder="Email" type="email">
                    <mat-error *ngIf="(formErrors.email)">{{formErrors.email}}</mat-error>
                </mat-form-field>
            </p>
            <table class="form-size">
                <td>
                    <mat-slide-toggle formControlName="agree">May we contact you?</mat-slide-toggle>
                </td>
                <td>
                    <mat-select placeholder="How?" formControlName="contacttype">
                        <mat-option *ngFor="let ctype of contactType" [value]="ctype">
                            {{ ctype }}
                        </mat-option>
                    </mat-select>
                </td>
            </table>
            <p>
                <mat-form-field class="full-width">
                    <textarea matInput formControlName="message" placeholder="Your Feedback" rows=12></textarea>
                    <mat-error *ngIf="checkError('message', 'required')">Feedback is required</mat-error>
                </mat-form-field>
            </p>
            <button type="submit" mat-button [disabled]="!feedbackForm.valid" class="background-primary button text-floral-white">Submit</button>
        </form>
    </div>
    <div *ngIf="submitted" [@expand]>
        <h3 style="text-align: center;">Your Submission</h3>
        <p style="text-align: center;">
            First Name: {{ feedback.firstname }} <br /> Last Name: {{ feedback.lastname }} <br /> Tel. Number: {{ feedback.telnum }} <br /> Email: {{ feedback.email }} <br /> Contact You?: {{ feedback.agree }} <br /> How?: {{ feedback.contacttype }} <br
            /> Feedback: {{ feedback.message }} <br />
        </p>
    </div>
    <div *ngIf="submitting">
        <h3 style="text-align: center;">Submitting</h3>
        <mat-spinner></mat-spinner>
    </div>
</div>